import React from "react";
import clsx from "clsx";

function ChatMessageBubble({
  message,
  isOwn,
}: {
  message: ChatMessage;
  isOwn: boolean;
}) {
  const hasSong = !!message.songId;

  return (
    <div
      data-message-id={message._docId}
      className={clsx(
        "flex flex-col mb-3 max-w-[80%]",
        isOwn ? "self-end items-end" : "self-start items-start"
      )}
    >
      {!isOwn && (
        <span className="text-xs text-esc-neutral-300 mb-0.5 ml-3">
          {message.userName}
        </span>
      )}

      {hasSong && (
        <div
          className={clsx(
            "flex items-center gap-2 px-3 py-1.5 text-xs",
            // isOwn
            //   ? "bg-esc-pink-700/60 border-esc-pink-400 text-white rounded-t-2xl"
            //   : "bg-esc-purple-700 border-esc-purple-400 text-white rounded-t-2xl"
          )}
        >
          {message.songCountry && (
            <span
              className={`fi fi-${message.songCountry} w-5 h-4 flex-none`}
              aria-hidden="true"
            ></span>
          )}
          <span className="flex flex-col leading-tight">
            <span className="opacity-70 text-[10px] uppercase tracking-wide">
              Comment on
            </span>
            <span className="font-montserrat font-semibold">
              {message.songTitle}
            </span>
            <span className="italic opacity-80">{message.songArtist}</span>
          </span>
        </div>
      )}

      <div
        className={clsx(
          "px-3 py-2 break-words whitespace-pre-wrap text-base",
          isOwn
            ? "bg-esc-pink-500 text-white rounded-2xl rounded-br-md"
            : "bg-esc-neutral-700 text-white rounded-2xl rounded-bl-md",
          hasSong && (isOwn ? "rounded-tr-md" : "rounded-tl-md")
        )}
      >
        {message.text}
      </div>
    </div>
  );
}

export default ChatMessageBubble;
